var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFocused)?_c('div',{staticClass:"focus-indicator-root",style:([_vm.geometryProperties, _vm.outlineProperties])}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }